/**
 * How many rows a list screen shows at once.
 *
 * The API's own default is 25 (`DEFAULT_PAGE_SIZE`), which is more rows than
 * fit above the fold on a laptop: the pager sits below the window, so a long
 * list looks like it has no pager at all and staff scroll the page instead of
 * turning it. Ten rows and the controls stay visible with the table.
 *
 * It is a frontend decision, not a change to the API default — an export or an
 * integration reading the same endpoint still gets 25.
 */
export const ROWS_PER_PAGE = 10;
